import { useMutation } from '@tanstack/react-query';

import { useToastStore } from '@pkg/components/Toast/useToastStore';
import {
    type MutationAccountCollectiblesHideArgs,
    type MutationAccountCollectiblesShowArgs,
} from '@pkg/graphql/codegen/graphql';
import { useQueryInvalidation } from '@pkg/hooks';
import { USER_WALLETS_BY_USER_CACHE } from '@pkg/hooks/wallets/useAccountsItems.ts';

import { callHideCollectibles, callShowCollectibles } from './request';

export function useToggleCollectiblesMutation() {
    const { addToast } = useToastStore();
    const invalidateWalletsCache = useQueryInvalidation([USER_WALLETS_BY_USER_CACHE]);

    const { mutateAsync: hideTokens } = useMutation({
        mutationFn: (params: MutationAccountCollectiblesHideArgs) => callHideCollectibles({ variables: params }),
        onMutate: () => {
            addToast({
                isLoader: true,
                message: `Workin' on it...`,
            });
        },
        onSuccess: () => {
            invalidateWalletsCache();

            addToast({
                emoji: '👻',
                message: 'NFT is hidden!',
            });
        },
    });

    const { mutateAsync: showTokens } = useMutation({
        mutationFn: (params: MutationAccountCollectiblesShowArgs) => callShowCollectibles({ variables: params }),
        onSuccess: () => {
            invalidateWalletsCache();

            addToast({
                emoji: '👀',
                message: 'NFT is visible!',
            });
        },
    });
    return {
        hideTokens,
        showTokens,
    };
}
